import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import ApexCharts from 'apexcharts';
import { AccountingReportService } from 'src/app/services/reports/accounting-report.service';
import { ColorUtil } from 'src/app/common/util';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { VendorService } from 'src/app/services/vendor.service';
import { VendorResponse } from 'src/app/models/vendor.model';

@Component({
  selector: 'app-budget-provider-report',
  templateUrl: './budget-provider-report.component.html',
  styleUrls: ['./budget-provider-report.component.scss']
})
export class BudgetProviderReportComponent implements OnInit, OnChanges {
  @Input() warehouse = null;
  months = {
    1: "Enero",
    2: "Febrero",
    3: "Marzo",
    4: "Abril",
    5: "Mayo",
    6: "Junio",
    7: "Julio",
    8: "Agosto",
    9: "Septiembre",
    10: "Octubre",
    11: "Noviembre",
    12: "Diciembre"
  }

  constructor(
    private accountingService: AccountingReportService,
    private toastService: ToastrService,
    private warehouseService: WarehouseService
  ) {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['warehouse'] && !changes['warehouse'].isFirstChange()) {
      this.updateChart();
    }
  }

  ngOnInit(): void {
      this.updateChart();
  }

  updateChart() {
    document.getElementById("provider-chart").innerHTML = "";
    this.accountingService.getBudgetProvider(this.warehouse).subscribe({
      next: (response: ResponseObject) => {
        console.log(response.data);
        var categories = [];
        var data = [];
        var total = { name: 'Total', data: [] };
        var total_taxes = { name: 'Total de Impuestos', data: [] };
        var budget = { name: 'Presupuesto', data: [] };
        response.data.forEach((r) => {
          total.data.push(r.total);
          total_taxes.data.push(r.total_taxes);
          budget.data.push(r.budget);
          categories.push(r.year + " - " + this.months[r.month])
        });
        data.push(budget);
        data.push(total);
        data.push(total_taxes);
        var options = {
          series: data,
          chart: {
            height: 350,
            type: 'bar',
            events: {
              click: function (chart, w, e) {
                // console.log(chart, w, e)
              }
            }
          },
          plotOptions: {
            bar: {
              columnWidth: '45%'
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: categories
          },
          tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
              console.log(series,seriesIndex,dataPointIndex,w);
              
              var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];

              return '<div style="padding:0.5em; margin:0;"><p class="h6">' + w.globals.labels[dataPointIndex] + '<span style="color:'+w.globals.colors[dataPointIndex]+';">⬤</span></p>' +
                '<p class="h4" style="color:'+w.globals.colors[dataPointIndex]+';"><b>Q ' + new Intl.NumberFormat('en-US').format(series[seriesIndex][dataPointIndex]) + '</b></p></div>';
            }
          }
        };

        var chart = new ApexCharts(document.querySelector("#provider-chart"), options);
        chart.render();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }
}
